import React from 'react';
import { Link } from 'react-router-dom';
import GoogleAuth from './GoogleAuth';
import { Menu } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { fetchCollections } from '../actions'

class DashboardHeader extends React.Component {
    render() {
        return (
            <Menu>
                <Menu.Item name="collections">
                    <Link to="/">Collections</Link></Menu.Item>
                <Menu.Item name="collections">
                    <Link to="/statistics">Statistics</Link>
                </Menu.Item>
                <GoogleAuth/>
            </Menu>
        )
    }
};

const mapStateToProps = (state) => {
    return { 
        year: state.dashboard.year,
        token: state.auth.token
     };
}

export default connect(mapStateToProps, { fetchCollections })(DashboardHeader);
